// extracted by mini-css-extract-plugin
export default {"btnTiertary":"BtnTiertary_btnTiertary__2zZic","disabled":"BtnTiertary_disabled__8GGO5"};